// noinspection DuplicatedCode

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '@/hocs/fetch';
import { withRouter } from '~/hocs/router';
import Form from './Form';

const initialValues = {
    statusFrom: '',
    statusTo: '',
    interval: '',
};

const initialErrors = {
    statusFrom: '',
    statusTo: '',
    interval: '',
};

let abortController;

const DialogAdd = (props) => {
    const offerName = props.match.params.offerName;

    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleSubmit = (event) => {
        abortController = new AbortController();
        event.preventDefault();
        setFetching(true);
        props.fetch.post(
            '/api/auto-statuses/', {
                offer_name: offerName, status_from: values.statusFrom, status_to: values.statusTo,
                interval: values.interval
            },
            abortController
        ).then(({ok, data}) => {
            if (ok) {
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.statusFrom = (data.status_from) ? data.status_from[0] : '';
                // noinspection JSUnresolvedVariable
                _errors.statusTo = (data.status_to) ? data.status_to[0] : '';
                _errors.interval = (data.interval) ? data.interval[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        clear();
        props.setOpen(false);
    };

    return (
        <DialogForm title="Добавление автоматического статуса" label="Добавить"
                    open={props.open} onSubmit={handleSubmit} onClose={handleClose}
                    disabled={fetching}
        >
            <Form values={values} setValues={setValues} errors={errors} setErrors={setErrors}/>
        </DialogForm>
    );
};

DialogAdd.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogAdd;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
